import React, { useState, useContext } from "react"
import PropTypes from "prop-types"
import { CartContext } from "../context/CartContext"
import Img from "gatsby-image"
import styled from "styled-components"
import { CollapseContext } from "../context/CollapseContext"
import { GrUp, GrDown } from "react-icons/gr"
import { displayPrice } from "@antoine-lb/business-logic"

const ProductTitle = styled.div`
  display: flex;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  color: #222;
  padding-right: 20px;
  p {
    font-size: 21px;
    display: inline;
  }
  span {
    font-size: 21px;
  }

  @media only screen and (max-width: 500px) {
    p {
      font-size: 14px;
    }
    span {
      font-size: 12px;
    }
    padding-right: 7px;
  }
`

const AddToCartButton = styled.button`
  margin-top: 20px;
  max-width: 300px;
  padding: 10px;
  background: #732619;
  font: 400 18px Marcellus, sans-serif;
  color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  border: none;
  cursor: pointer;
  :active {
    background: #732619cc;
  }

  @media only screen and (max-width: 500px) {
    font-size: 13px;
  }
`
const ProductExtended = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
`

const CollapseContainer = styled.div`
  border-bottom: 1px solid #eee;
  flex-grow: 1;
  margin: 0 5px;

  @media only screen and (max-width: 500px) {
    font-size: 13px;
  }
`

const CollapseButton = styled.div`
  background-color: white;
  font-size: 26px;
  cursor: pointer;
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const CollapseIcon = styled.div`
  svg {
    polyline {
      stroke: #555;
    }
  }

  @media only screen and (max-width: 500px) {
    font-size: 14px;
  }
`
const ImageAndName = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
`

const ProductImg = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  margin-right: 8px;

  @media only screen and (max-width: 500px) {
    width: 60px;
    height: 60px;
  }
`

const Product = ({ product }) => {
  const [qty] = useState(1)
  const { addToCart } = useContext(CartContext)
  const { toggleCollapse, isOpen } = useContext(CollapseContext)

  return (
    <CollapseContainer>
      <CollapseButton
        onClick={() => {
          toggleCollapse(product.product_id)
        }}
      >
        <ProductTitle>
          <ImageAndName>
            <ProductImg>
              {product.thumbnail ? (
                <Img
                  fluid={product.thumbnail.childImageSharp.fluid}
                  style={{
                    boxShadow:
                      "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)",
                    borderRadius: "4px",

                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "100%",
                    height: "100%",
                  }}
                />
              ) : null}
            </ProductImg>
            <p>{product.name}</p>
          </ImageAndName>
          <span>${displayPrice(product.price_in_cent)}</span>
        </ProductTitle>
        <CollapseIcon>
          {isOpen(product.product_id) ? <GrUp /> : <GrDown />}
        </CollapseIcon>
      </CollapseButton>
      {isOpen(product.product_id) ? (
        <ProductExtended>
          <span>{product.description}</span>
          <AddToCartButton onClick={() => addToCart(product, qty)}>
            Agregar al Carro
          </AddToCartButton>
          {/* <input
          type="number"
          value={qty}
          onChange={event => setQty(event.target.value)}
        /> */}
        </ProductExtended>
      ) : null}
    </CollapseContainer>
  )
}

Product.propTypes = {
  product: PropTypes.object,
}

export default Product
